/** @file TODO: documentar */
import { debounce } from 'lodash-es';

import onmount from 'onmount';

$.onmount = onmount;

// hacemos un debounce de 0 segundos porque intercooler podria llamar multiples veces en un loop
// asi que lo hacemos que se ejecute una sola vez en el siguiente event loop
const f = () => onmount();
const debounced = debounce(f, 0);

const events = [
  'ready',
  'shown.bs.modal',
  'closed.bs',
  'load',
  'page:change',
  'turbolinks:load',
  'nodesProcessed.ic',
  'buk:load-content',
  'cocoon:after-insert',
  'cocoon:after-remove',
].join(' ');

$(document).ready(debounced);

$(document).ready(function () {
  onmount.teardown();
});

$(document).on('draw.dt', debounced);

/** Obtiene una descripción en texto del elemento
 * @param {Element} el
 */
function getElementDescription(el) {
  if (el.id) {
    return `${el.nodeName}#${el.id}`;
  }
  else if (el.name) {
    return `${el.nodeName}[name="${el.name}"]`;
  }
  else {
    // El nodo completo
    let html = el.outerHTML;
    if (el.innerHTML) {
      // Pero sin el contenido
      html = html.replace(el.innerHTML, '');
    }
    return html;
  }
}

/** Obtiene el prototipo de la clase interna Behavior de onmount
 *
 * Como la clase no es pública hay que hacer una maroma para poder hacerle
 * monkey patch
 *
 * @returns {Object}
 */
function getBehaviorsPrototype() {
  // Puede que a esta altura no tengamos ningun behavior registrado
  // Si no hay, creamos uno dummy
  if (onmount.behaviors.length > 0) {
    return onmount.behaviors[0].constructor.prototype;
  }
  else {
    onmount('document', () => {});
    const proto = onmount.behaviors[0].constructor.prototype;
    onmount.reset();
    return proto;
  }
}

// HACK: patcheamos onmount para agregar contexto del elemento que gatilló el problema
const onmountBehaviorProto = getBehaviorsPrototype();

// Invoca la funcion pasada como argumento, wrapeandola con sentry (si ya existe)
function callWithSentry(oldFunc) {
  return function (...args) {
    const self = this;
    const Sentry = window.Sentry;
    // el elemento siempre es el primer argumento
    const el = args[0];
    if (Sentry) {
      Sentry.withScope(function (scope) {
        try {
          oldFunc.apply(self, args);
        }
        catch (e) {
          scope.setExtra('element', getElementDescription(args[0]));
          Sentry.captureException(e);
        }
      });
    }
    else {
      oldFunc.call(self, el);
    }
  };
}

onmountBehaviorProto.visitEnter = callWithSentry(onmountBehaviorProto.visitEnter);
// Teardown no pasa por visitExit :shrug:
onmountBehaviorProto.doExit = callWithSentry(onmountBehaviorProto.doExit);
